import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/styles';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import AlertDialogSlide from 'common/components/dialog/dialog';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import LoadingProgress from 'common/components/progress/loading';
import styles from 'material-dashboard-assets/jss/material-dashboard-react/views/dashboardStyle.js';
import Card from 'material-dashboard-components/Card/Card.js';
import CardFooter from 'material-dashboard-components/Card/CardFooter.js';
import CardHeader from 'material-dashboard-components/Card/CardHeader.js';
import CardIcon from 'material-dashboard-components/Card/CardIcon.js';
import GridContainer from 'material-dashboard-components/Grid/GridContainer.js';
import GridItem from 'material-dashboard-components/Grid/GridItem.js';
import { getActionResults } from 'modules/owner/pages/actions/activeActions/activeActionsScripts.js';
import React, { Component } from 'react';
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Button, Typography } from '@material-ui/core';
import { ColumnsBelowSearch, NumberGenericElement } from 'common/components/table/tableComponents';
import Table from 'common/components/table/table-material';
import VoucherTable from './VoucherTable';
import UserDetails from '../../userDetails/UserDetails';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { getListall } from '../../validators/validatorsActions.js';
import * as XLSX from 'xlsx';
import { ro } from 'date-fns/locale';
import { BASE_API, BASE_S3, USER_KEY, USER_TOKEN } from 'config/consts';
import axios from 'axios';
import html2canvas from 'html2canvas';
import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  LineSeries,
  VerticalBarSeries,
} from 'react-vis';
import { Chart, registerables } from 'chart.js/auto';
import ReactDOM from 'react-dom';
import { csvCell as escapeCsvCell } from 'helpers/csv';
const { format } = require('date-fns');

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = { userSelected: {}, openDetails: false };
    this.props.getActionResults(this.props.location.query.action);
    this.props.getListall(this.props.auth.user.establishments[0].stations[0].id);
    this.closeDetails = this.closeDetails.bind(this);
  }
  getSubscriptionEntity = (user, pcs) =>
    pcs.station_name || pcs.presential_course?.action?.station?.name || user.station_name || '';

  converterParaCSV = (listaDeInformacao, validador) => {
    let j = 0;
    let contador = 0;
    if (!Array.isArray(listaDeInformacao) || listaDeInformacao.length === 0) {
      console.error('Lista de objetos vazia ou inválida.');
      return '';
    }
    // Obtém os cabeçalhos do CSV a partir das chaves selecionadas
    const cabe = [
      'Nome',
      'Entidade',
      'CPF',
      'Telefone',
      'Voucher',
      'Emissão',
      'Validador',
      'Validação',
    ];

    // Gera as linhas do CSV
    const linhas = [];
    for (let i = 0; i < listaDeInformacao.length; i++) {
      const user = listaDeInformacao[i];
      const subscriptions = user.presential_course_subscriptions || [];
      for (let a = 0; a < subscriptions.length; a++) {
        const pcs = subscriptions[a];
        const createdat = new Date(pcs.createdAt);
        const validation_date = new Date(pcs.validation_date);

        linhas[`${j}`] = [];
        linhas[j].push(escapeCsvCell(user.name));
        linhas[j].push(escapeCsvCell(this.getSubscriptionEntity(user, pcs)));
        linhas[j].push(escapeCsvCell(user.cpf));
        linhas[j].push(escapeCsvCell(user.tel));
        linhas[j].push(escapeCsvCell(pcs.code));
        linhas[j].push(escapeCsvCell(format(createdat, 'dd/MM/yyyy HH:mm:ss')));
        linhas[j].push(escapeCsvCell(this.Validador(validador, pcs.code_validator_id)));
        if (pcs.validated === '1') {
          linhas[j].push(escapeCsvCell(format(validation_date, 'dd/MM/yyyy HH:mm:ss')));
          contador++;
        } else {
          linhas[j].push(escapeCsvCell(pcs.validation_date));
        }
        j++;
      }
    }
    linhas[`${j}`] = [];
    linhas[j].push(contador);
    const linhasCSV = linhas.map((linha) => linha.join(','));
    const csv = [cabe.join(','), ...linhasCSV].join('\n');

    return csv;
  };

  gerarExcel = (csvString, titulo, actionName = '') => {
    try {
      // Parse da string CSV para um array de arrays
      const nomeAtividade =
        titulo[0]?.presential_course_subscriptions[0]?.presential_course?.action?.name ||
        actionName;
      const dataAtual = new Date();
      const dia = dataAtual.getDate();
      const mes = dataAtual.getMonth() + 1; // Adicione 1 porque os meses começam do zero
      const ano = dataAtual.getFullYear();
      const csvData = csvString.split('\n').map((row) => row.split(','));
      // Crie um workbook do Excel
      const workbook = XLSX.utils.book_new();
      // Crie uma planilha a partir dos dados CSV
      const worksheet = XLSX.utils.aoa_to_sheet(csvData);
      // Adicione a planilha ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
      // Salve o workbook como um arquivo Excel
      XLSX.writeFile(workbook, `relatorio_${nomeAtividade}_${dia}_${mes}_${ano}.xlsx`);
    } catch (error) {
      toastr.error('Erro', 'Não foi possível exportar o relatório.');
      console.error('Não foi possível gerar o relatório.', error);
    }
  };

  Validador = (validador, code) => {
    for (let b = 0; b < validador.length; b++) {
      if (code === validador[b].id) {
        return validador[b].identification;
      }
    }
    return ' ';
  };
  agruparPorDiaValidados = (vouchers, anoAc, mesAc) => {
    const contagemPorDia = {};
    vouchers.forEach((voucher) => {
      if (!voucher.validation_date) return;
      const data = new Date(voucher.validation_date);
      const dia = data.getDate();
      const mes = data.getMonth(); // 0 = janeiro, ..., 3 = abril
      const ano = data.getFullYear();
      // Considerando apenas o mês e ano específicos (ex: abril/2024)
      if (ano === anoAc && mes === mesAc) {
        const chave = `${ano}-${mes + 1}-${dia}`;
        contagemPorDia[chave] = (contagemPorDia[chave] || 0) + 1;
      }
    });
    return contagemPorDia;
  };

  agruparPorDiaGerados = (vouchers, anoAc, mesAc) => {
    const contagemPorDia = {};
    vouchers.forEach((voucher) => {
      if (!voucher.createdAt) return;
      const data = new Date(voucher.createdAt);
      const dia = data.getDate();
      const mes = data.getMonth(); // 0 = janeiro, ..., 3 = abril
      const ano = data.getFullYear();
      // Considerando apenas o mês e ano específicos (ex: abril/2024)
      if (ano === anoAc && mes === mesAc) {
        const chave = `${ano}-${mes + 1}-${dia}`;
        contagemPorDia[chave] = (contagemPorDia[chave] || 0) + 1;
      }
    });
    return contagemPorDia;
  };

  getDiasDoMes = (ano, mes) => {
    const dias = [];
    const data = new Date(ano, mes, 1);
    while (data.getMonth() === mes) {
      const diaFormatado = String(data.getDate());
      const mesFormatado = String(data.getMonth() + 1);
      dias.push(`${ano}-${mesFormatado}-${diaFormatado}`);
      data.setDate(data.getDate() + 1);
    }
    return dias;
  };

  criarLista = async () => {
    try {
      // Faz a chamada à API usando axios
      const response = await axios.get(
        `${BASE_API}/data-vouchers/${this.props.activeActions.actionResults.action.id}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      );

      // Extrai os dados da resposta
      const { data } = response;

      // Exibe os dados no console (opcional)
      const subscriptions = data.subscriptions;
      const numValidados = subscriptions.filter((item) => item.validated === '1').length;
      const dataStr = data.action.createdAt;
      const dataAction = new Date(dataStr);
      const ano = dataAction.getFullYear();
      const mes = dataAction.getMonth();
      const diasDoMes = this.getDiasDoMes(ano, mes);
      const contagemValidados = this.agruparPorDiaValidados(subscriptions, ano, mes);
      const contagemGerados = this.agruparPorDiaGerados(subscriptions, ano, mes);
      const dadosEixoYval = diasDoMes.map((dia) => contagemValidados[dia] || 0);
      const dadosEixoYgera = diasDoMes.map((dia) => contagemGerados[dia] || 0);

      return {
        nomeAction: data.action.name,
        actionStart: data.action.participationStart,
        actionEnd: data.action.participationEnd,
        nameStation: data.action.station.name,
        estoque: data.action.limit,
        numTotalVouchers: data.subscriptions.length,
        numValidados: numValidados,
        diasDoMes: diasDoMes,
        dadosEixoYval: dadosEixoYval,
        dadosEixoYgera: dadosEixoYgera,
      };
    } catch (e) {
      // Trata erros de requisição
      console.error('Erro na requisição:', e);
    }
  };

  criarGraficoLinha = (dataArray1, dataArray2) => {
    return new Promise((resolve) => {
      // Cria um container temporário no DOM para renderizar o gráfico
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.top = '-9999px';
      container.style.width = '400px';
      container.style.height = '300px';
      container.style.backgroundColor = 'transparent';
      document.body.appendChild(container);

      // Estilo da legenda (inline)
      const legendStyle = {
        position: 'absolute',
        top: '25px',
        right: '15px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: '8px',
        borderRadius: '4px',
        fontFamily: 'sans-serif',
        fontSize: '12px',
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      };

      const itemStyle = {
        display: 'flex',
        alignItems: 'center',
      };

      const lineStyle = (color) => ({
        width: '12px',
        height: '2px',
        backgroundColor: color,
        marginRight: '6px',
      });

      // Define o gráfico + legenda como componente React
      const chart = (
        <div style={{ position: 'relative', width: '400px', height: '300px' }}>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#fff',
              textAlign: 'center',
              width: '100%',
              pointerEvents: 'none',
              zIndex: 10,
            }}>
            Evolução Diária de Voucher's: Gerados vs Validados
          </div>
          {/* Gráfico */}
          <XYPlot
            width={400}
            height={300}
            style={{
              backgroundColor: '#9021a1', // Fundo do gráfico
              fill: 'none',
            }}>
            <VerticalGridLines />
            <HorizontalGridLines />
            <XAxis
              title="Dias"
              tickLabelAngle={-45}
              style={{
                line: { stroke: '#fff' },
                ticks: { stroke: '#fff' },
                text: { stroke: 'none', fill: '#fff', fontSize: '10px' },
                title: { stroke: 'none', fill: '#fff', fontSize: '14px' },
              }}
            />
            <YAxis
              title="Voucher's"
              style={{
                line: { stroke: '#fff' },
                ticks: { stroke: '#fff' },
                text: { stroke: 'none', fill: '#fff', fontSize: '10px' },
                title: { stroke: 'none', fill: '#fff', fontSize: '14px' },
              }}
            />
            <LineSeries data={dataArray1} color="#ff7f0e" strokeWidth={3} opacity={0.8} />
            <LineSeries data={dataArray2} color="#1f77b4" strokeWidth={3} opacity={0.8} />
          </XYPlot>

          {/* Legenda personalizada */}
          <div style={legendStyle}>
            <div style={itemStyle}>
              <span style={lineStyle('#ff7f0e')}></span>
              Gerados
            </div>
            <div style={itemStyle}>
              <span style={lineStyle('#1f77b4')}></span>
              Validados
            </div>
          </div>
        </div>
      );

      // Usa ReactDOM.createRoot para renderizar o componente React
      ReactDOM.render(chart, container);

      // Aguarda a renderização completa antes de capturar a imagem
      setTimeout(() => {
        html2canvas(container, {
          useCORS: true,
          scale: 2,
          logging: false,
        }).then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          document.body.removeChild(container); // Limpa o DOM
          resolve(imgData); // Resolve com a imagem base64
        });
      }, 1000); // Ajuste conforme necessário
    });
  };
  criarGraficoDonut = (valores, labels) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 300;
      canvas.style.position = 'absolute';
      canvas.style.top = '-9999px';
      document.body.appendChild(canvas);
      const ctx = canvas.getContext('2d');

      // Junta labels e valores para mostrar na legenda
      const legendLabels = labels.map((label, i) => `${label}: ${valores[i].toFixed(1)}%`);

      const chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: legendLabels, // Agora mostra label + valor
          datasets: [
            {
              label: 'Dados',
              data: valores,
              backgroundColor: ['#E78733', '#FFFFFF'],
              borderColor: '#fff',
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#fff', // Cor da legenda
                font: {
                  weight: 'bold', // Negrito
                  size: 23, // Tamanho da fonte (opcional)
                },
              },
            },
            tooltip: { enabled: true },
          },
        },
      });

      setTimeout(() => {
        const imgData = canvas.toDataURL('image/png');
        document.body.removeChild(canvas);
        resolve(imgData);
      }, 1000); // Tempo suficiente para renderizar
    });
  };
  criarGraficoBarraVertical = (porcentagem) => {
    return new Promise((resolve) => {
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.top = '-9999px';
      container.style.width = '300px';
      container.style.height = '300px';
      container.style.backgroundColor = 'transparent';
      document.body.appendChild(container);

      // Dado único para exibir a porcentagem
      const data = [{ x: 'Estoque', y: porcentagem }];

      // Define o gráfico como componente React
      const chart = (
        <div style={{ position: 'relative', width: '300px', height: '300px' }}>
          {/* Título */}
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#fff',
              textAlign: 'center',
              width: '100%',
              pointerEvents: 'none',
              zIndex: 10,
            }}>
            Movimento do Estoque: Movimentação e Limite
          </div>

          {/* Gráfico */}
          <XYPlot
            width={300}
            height={300}
            yDomain={[0, 100]}
            xType="ordinal"
            xDomain={['']}
            style={{
              backgroundColor: '#9021a1',
            }}
            margin={{ left: 60, right: 20, top: 30, bottom: 70 }}>
            <VerticalGridLines />
            <HorizontalGridLines />

            <XAxis
              tickLabelAngle={0}
              hideLine
              hideTicks
              style={{
                text: { fill: '#fff', fontSize: '12px' },
              }}
            />

            <YAxis
              tickFormat={(v) => `${v}%`}
              title="%"
              style={{
                line: { stroke: '#fff' },
                ticks: { stroke: '#fff' },
                text: { fill: '#fff', fontSize: '10px' },
                title: { fill: '#fff', fontSize: '14px' },
              }}
            />
            {/* Barra vertical */}
            <VerticalBarSeries data={data} color="#e78733" barWidth={0.25} animation />
          </XYPlot>

          {/* Texto centralizado dentro da barra */}
          <div
            style={{
              position: 'absolute',
              top: '100px',
              left: '70%',
              transform: 'translateX(-50%)',
              color: '#fff',
              fontSize: '45px',
              fontWeight: 'bold',
              pointerEvents: 'none',
              width: '100%',
              textAlign: 'center',
            }}>
            {porcentagem.toFixed(1)}%
          </div>
        </div>
      );

      ReactDOM.render(chart, container);

      setTimeout(() => {
        html2canvas(container, {
          useCORS: true,
          scale: 2,
          logging: false,
        }).then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          document.body.removeChild(container);
          resolve(imgData);
        });
      }, 1000);
    });
  };
  gerarPDF = (csvData, titulo, actionName = '') => {
    try {
      if (!csvData || !csvData.trim()) {
        toastr.error('Erro', 'Não há dados para exportar.');
        return;
      }
      const dataAtual = new Date();
      const dia = dataAtual.getDate();
      const mes = dataAtual.getMonth() + 1; // Adicione 1 porque os meses começam do zero
      const ano = dataAtual.getFullYear();
      const doc = new JsPDF({ orientation: 'landscape' });
      const nomeAtividade =
        titulo[0]?.presential_course_subscriptions[0]?.presential_course?.action?.name ||
        actionName;
      const options = {
        margin: { top: 5 },
        headStyles: { fontSize: 10 }, // Tamanho da fonte para o cabeçalho
        bodyStyles: { fontSize: 9 }, // Tamanho da fonte para o corpo
        startY: 20,
      };
      // Analise a string CSV para obter os dados da tabela
      const rows = csvData.split('\n').map((row) => row.split(','));
      // Remove apenas CPF; mantém Entidade e Telefone no PDF
      const columnsToRemove = [2];
      const filteredRows = rows.map((row) =>
        row.filter((_, index) => !columnsToRemove.includes(index))
      );
      const nome = filteredRows[1];
      let validados = filteredRows[filteredRows.length - 1];
      validados = parseInt(validados[0]);
      let gerados = filteredRows.length - 2;
      filteredRows.pop();
      // Adicione o título
      doc.text(`Relatorio ${nomeAtividade}, ${dia}/${mes}/${ano}`, 14, 10);
      // Crie a tabela
      doc.autoTable({
        head: [filteredRows[0]], // Cabeçalho da tabela
        body: filteredRows.slice(1), // Corpo da tabela
        ...options,
      });
      let texto = `${validados} Validados : Litros ${validados * 20}\n${gerados} Gerados : Litros ${
        gerados * 20
      }`;
      doc.setFontSize(10);
      doc.text(texto, 14, doc.lastAutoTable.finalY + 10);

      // Salve o PDF
      doc.save(`relatorio_${nomeAtividade}_${dia}_${mes}_${ano}.pdf`);
    } catch (error) {
      toastr.error('Erro', 'Não foi possível exportar o relatório.');
      console.error('Não foi possível gerar o relatório.', error);
    }
  };

  relatorioPDF = async () => {
    const agora = new Date();
    const dataBrasil = agora.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    const dados = await this.criarLista();
    console.log(dados);
    const doc = new JsPDF({
      orientation: 'portrait', // 'portrait' ou 'landscape'
      unit: 'mm', // Unidade de medida (milímetros)
      format: [120, 400], // Tamanho personalizado: largura, altura
    });
    // Definir a cor de fundo
    doc.setFillColor(231, 135, 51); // RGB: laranja (R=, G=, B=)
    doc.rect(0, 0, 120, 400, 'F'); // Largura, Altura, Tipo = "F" (preenchido)

    doc.setFillColor(144, 33, 161); // RGB: (R=, G=, B=)
    doc.roundedRect(5, 5, 110, 390, 10, 10, 'F'); // roxo Largura, Altura, Tipo = "F" (preenchido)
    // Adicionar conteúdo ao PDF
    doc.setFontSize(13);
    doc.setTextColor(255, 255, 255); // Definir cor do texto para preto
    doc.text(`        Gerado em: \n ${dataBrasil} `, 62, 16);
    // linhas brancas 1
    doc.setFillColor(255, 255, 255); // RGB: branca (R=, G=, B=) linha
    doc.rect(5, 30, 80, 1, 'F'); // Largura, Altura, Tipo = "F" (preenchido)
    // Retagulo circular 1
    doc.setFillColor(231, 135, 51); // Cor de preenchimento
    doc.roundedRect(10, 35, 100, 20, 10, 10, 'F'); // x=20mm, y=20mm, largura=100mm, altura=20mm, rx=10mm, ry=10mm
    // texto 2
    doc.setFont('helvetica', 'bold'); // Define fonte e estilo como negrito
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255); // Definir cor do texto para preto
    doc.text(`Entidade:    ${dados.nameStation} `, 17, 47);
    // Retagulo circular 2
    doc.setFillColor(231, 135, 51); // Cor de preenchimento
    doc.roundedRect(10, 60, 100, 20, 10, 10, 'F'); // x=20mm, y=20mm, largura=100mm, altura=50mm, rx=10mm, ry=10mm
    // texto 3
    const nomeAction = dados.nomeAction || '';
    // Definir limite de caracteres
    const limite = 17;
    // Adicionar ... se passar do limite
    const nomeFormatado =
      nomeAction.length > limite ? nomeAction.substring(0, limite) + '...' : nomeAction;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    doc.setTextColor(255, 255, 255); // Branco
    doc.text(`Campanha:    ${nomeFormatado}`, 17, 72);
    // linhas brancas 2
    doc.setFillColor(255, 255, 255); // RGB: branca (R=, G=, B=) linha
    doc.rect(35, 85, 80, 1, 'F'); // Largura, Altura, Tipo = "F" (preenchido)

    // Adicionar conteúdo ao PDF
    doc.setFontSize(15);
    doc.setTextColor(255, 255, 255); // Definir cor do texto para preto
    doc.text('Total de Vouchers:', 38, 97.5);
    // Retagulo circular 3
    doc.setFillColor(255, 255, 255); // Cor de preenchimento
    doc.roundedRect(20, 100, 80, 20, 10, 10, 'F'); // x=20mm, y=20mm, largura=100mm, altura=50mm, rx=10mm, ry=10mm
    // numero de vouchers
    doc.setFont('helvetica', 'bold'); // Define fonte e estilo como negrito
    doc.setFontSize(22);
    doc.setTextColor(214, 129, 32); // Definir cor do texto para preto
    doc.text(`${dados.numTotalVouchers} `, 52, 112);
    // texto 4
    doc.setFontSize(15);
    doc.setTextColor(255, 255, 255); // Definir cor do texto para preto
    doc.text('Total de Vouchers validados:', 25, 128);
    // Retagulo circular 4
    doc.setFillColor(255, 255, 255); // Cor de preenchimento
    doc.roundedRect(20, 130, 80, 20, 10, 10, 'F'); // x=20mm, y=20mm, largura=100mm, altura=50mm, rx=10mm, ry=10mm
    // Vouchers validados
    doc.setFont('helvetica', 'bold'); // Define fonte e estilo como negrito
    doc.setFontSize(22);
    doc.setTextColor(214, 129, 32); // Definir cor do texto para preto
    doc.text(`${dados.numValidados} `, 52, 142);
    const VoucherValidados = (dados.numValidados / dados.numTotalVouchers) * 100;
    const VoucherNvalidados = 100 - VoucherValidados;
    // texto 5
    doc.setFontSize(13);
    doc.setTextColor(255, 255, 255); // Definir cor do texto para preto
    doc.text("Conversção de \n   Voucher's:", 74, 157);
    // Desenha o círculo
    doc.setDrawColor(231, 135, 51);
    doc.setFillColor(231, 135, 51);
    doc.circle(90, 180, 15, 'F'); // (x, y, raio)
    // porcentagem de coversão
    doc.setFontSize(25);
    doc.setTextColor(255, 255, 255); // Definir cor do texto para preto
    doc.text(`${VoucherValidados.toFixed(1)}%`, 79, 182);

    // linhas brancas 3
    doc.setFillColor(255, 255, 255); // RGB: branca (R=, G=, B=) linha
    doc.rect(5, 210, 80, 1, 'F'); // Largura, Altura, Tipo = "F" (preenchido)

    // linhas brancas 4
    doc.setFillColor(255, 255, 255); // RGB: branca (R=, G=, B=) linha
    doc.rect(35, 305, 80, 1, 'F'); // Largura, Altura, Tipo = "F" (preenchido)

    const valoresDonut = [VoucherValidados, VoucherNvalidados];
    const labelsDonut = ['Validados', 'Não Validados'];
    const xValues = dados.diasDoMes;
    const yValues1 = dados.dadosEixoYgera;
    const yValues2 = dados.dadosEixoYval;

    const diasNumeros = xValues.map((data) => {
      const partes = data.split('-');
      return parseInt(partes[2], 10); // Converte para número
    });
    // Converter arrays para o formato aceito pelo react-vis
    const data1 = diasNumeros.map((x, i) => ({ x, y: yValues1[i] }));
    const data2 = diasNumeros.map((x, i) => ({ x, y: yValues2[i] }));
    const porcentagemUsados = (dados.numValidados / dados.estoque) * 100;
    // Gerar gráficos como imagens
    const imgDonut = await this.criarGraficoDonut(valoresDonut, labelsDonut);
    const imgLinha = await this.criarGraficoLinha(data1, data2);
    const imgBarra = await this.criarGraficoBarraVertical(porcentagemUsados);

    // Adicionar ao PDF
    doc.addImage(imgDonut, 'PNG', 15, 160, 40, 40);
    doc.addImage(imgLinha, 'PNG', 5, 215, 105, 85); // Posição X, Y, Largura, Altura
    doc.addImage(imgBarra, 'PNG', 5, 310, 105, 85); // Posição X, Y, Largura, Altura
    doc.save(`relatorio_${dados.nomeAction}_${dataBrasil}.pdf`);
  };

  onDialogClose = () => {
    if (this.props.location.query.from === 'inicio') {
      this.props.router.push('/owner/acoes/inicio');
    } else {
      this.props.router.push(
        `/owner/acoes/minhas-atividades/?to=${this.props.location.query.from}`
      );
    }
  };
  renderEmptyScreen() {
    return (
      <AlertDialogSlide
        title="Resultados"
        visible
        height="95vh"
        onClose={this.onDialogClose}
        maxWidth={isMobile ? 'xl' : 'sm'}>
        <section id="statement-buy-points" style={{ height: '100vh' }}>
          <GeneralGrid container spacing={3} alignItems="center">
            <GeneralGrid item xs={12} md={6}>
              <GeneralGrid container spacing={3}>
                <GeneralGrid item xs={12}>
                  <h2 className="signup-text">Ninguém participou dessa atividade até o momento</h2>
                  <p>Aqui você poderá distribuir os prêmios</p>
                </GeneralGrid>
              </GeneralGrid>
            </GeneralGrid>
            <GeneralGrid item xs={12} md={6}>
              <img alt="" src={placeholder_illustration} className="img-fluid" />
            </GeneralGrid>
          </GeneralGrid>
        </section>
      </AlertDialogSlide>
    );
  }

  openDetails(rowData) {
    this.setState((state) => ({
      ...state,
      userSelected: rowData,
      openDetails: true,
    }));
  }

  closeDetails() {
    this.setState((state) => ({
      ...state,
      openDetails: false,
    }));
  }

  renderBackground = () => '#3f51b5';

  render() {
    const { classes } = this.props;
    const { actionResults, loadingActionResults, actionDetail } = this.props.activeActions;
    const { impressions, reach, participations, cashback, cashback_left, usersReached } =
      actionResults;
    const validador = this.props.validatorCode.list.content;
    const CSVprint = this.converterParaCSV(usersReached, validador);
    if (loadingActionResults) {
      return (
        <AlertDialogSlide
          title="Resultados"
          visible
          height="95vh"
          onClose={this.onDialogClose}
          maxWidth={isMobile ? 'xl' : 'md'}>
          <div className="d-flex justify-content-center mt-5">
            <LoadingProgress />
          </div>
        </AlertDialogSlide>
      );
    }

    return (
      <AlertDialogSlide
        isFullScreen={isMobile}
        title={`${actionDetail.name}`}
        visible
        height="95vh"
        onClose={this.onDialogClose}
        maxWidth={isMobile ? 'xl' : 'md'}>
        <Typography variant="h6">Resultados gerais</Typography>
        <GridContainer>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">remove_red_eye</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Impressões</p>
                <h3 className={classes.cardTitle}>{impressions}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a quantidade de visualizações que sua atividade teve, independente se for do mesmo usuário ou de usuários diferentes."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">people_alt</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Alcance</p>
                <h3 className={classes.cardTitle}>{reach}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a quantidade de participantes que viram sua atividade."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">call_made</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Participações</p>
                <h3 className={classes.cardTitle}>{participations.length}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a quantidade de participações efetivas na sua atividade."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">bar_chart</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Conversão</p>
                <h3 className={classes.cardTitle}>
                  {parseFloat((participations.length / reach) * 100).toFixed(1)}%
                </h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a porcentagem de pessoas que participaram dessa atividade em relação a todas que foram alcançadas"
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">attach_money</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Gasto atual</p>
                <h3 className={classes.cardTitle}>R${parseFloat(cashback).toFixed(2)}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="Essa é quantidade de dinheiro que já foi paga em cashback."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">money</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Cashback restante</p>
                <h3 className={classes.cardTitle}>R${parseFloat(cashback_left).toFixed(2)}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="Essa é a quantidade de dinheiro que foi reservada para ação mas ainda não foi distribuida em cashback."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GeneralGrid container spacing={3}>
          <GeneralGrid item xs={12}>
            {!_.isEmpty(usersReached) && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '8px',
                }}>
                <button
                  type="button"
                  onClick={() => this.gerarPDF(CSVprint, usersReached, actionDetail.name)}
                  aria-label="Gerar PDF">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: 'red', fontSize: '25px' }} />
                </button>
                <button type="button" onClick={() => this.relatorioPDF()} aria-label="Gerar PDF">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: 'blue', fontSize: '25px' }} />
                </button>
                <button
                  type="button"
                  onClick={() => this.gerarExcel(CSVprint, usersReached, actionDetail.name)}
                  aria-label="Gerar Excel">
                  <FontAwesomeIcon icon={faBook} style={{ color: 'green', fontSize: '25px' }} />
                </button>
              </div>
            )}
            <Table
              searchPlaceholder={'Procurar por nome de usuário'}
              hasToolbar={true}
              defaultSelected=""
              title="Extrato"
              columns={[
                { field: 'name', title: 'Nome' },
                { field: 'station_name', title: 'Entidade' },
                {
                  field: 'quantity',
                  title: 'Visualizações',
                  render: (rowData) => (
                    <NumberGenericElement category="visualizations" value={rowData.quantity} />
                  ),
                },
                {
                  title: 'Participação',
                  render: (rowData) =>
                    rowData.user_actions.length > 0 ? 'Visualizou e participou' : 'Visualizou',
                },
                {
                  title: 'Email',
                  field: 'email',
                },
                {
                  title: 'Detalhes',
                  field: 'search',
                  render: (rowData) => (
                    <ColumnsBelowSearch
                      buttons={{
                        namedButtons: [
                          {
                            name:
                              rowData.user_actions.length > 0 ? (
                                <Button
                                  variant="contained"
                                  onClick={() => this.openDetails(rowData)}>
                                  Ver detalhes
                                </Button>
                              ) : (
                                'Ainda não participou'
                              ),
                            onClick: () => {},
                            disabled: true,
                          },
                        ],
                        iconButtons: [],
                      }}
                    />
                  ),
                },
              ]}
              rows={usersReached}
              toolbarSearch
              mobileTable={isMobile}
              hasBorder={!isMobile}
            />
          </GeneralGrid>
          <GeneralGrid item spacing={3}>
            <VoucherTable />
          </GeneralGrid>
        </GeneralGrid>
        <UserDetails
          open={this.state.openDetails}
          data={this.state.userSelected}
          onClose={this.closeDetails}
          actionType={this.props.activeActions.actionDetail.type_id}></UserDetails>
      </AlertDialogSlide>
    );
  }
}

Results.propTypes = {
  activeActions: PropTypes.shape({
    actionResults: PropTypes.shape({
      action: PropTypes.any,
      cashback: PropTypes.any,
      cashback_left: PropTypes.any,
      impressions: PropTypes.any,
      participations: PropTypes.shape({
        length: PropTypes.any,
      }),
      reach: PropTypes.any,
      usersReached: PropTypes.any,
    }),
    loadingActionResults: PropTypes.any,
    actionDetail: PropTypes.shape({
      end: PropTypes.any,
      name: PropTypes.any,
      start: PropTypes.any,
    }),
  }),
  classes: PropTypes.shape({
    cardCategory: PropTypes.any,
    cardTitle: PropTypes.any,
    stats: PropTypes.any,
  }),
  getActionResults: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      action: PropTypes.any,
      from: PropTypes.string,
    }),
  }),
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  activeActions: state.activeActions,
  validatorCode: state.validatorCode,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getActionResults,
      getListall,
    },
    dispatch
  );

const StyledResults = withStyles(styles)(Results);

export default connect(mapStateToProps, mapDispatchToProps)(StyledResults);
